import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from './ui/button';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a cookie choice
    const cookieChoice = localStorage.getItem('kayaclean-cookie-consent');
    if (!cookieChoice) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('kayaclean-cookie-consent', 'all');
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('kayaclean-cookie-consent', 'necessary');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-slate-200 shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Text */}
          <div className="flex-1 pr-4">
            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
              Diese Website verwendet Cookies, um die Funktionalität der Seite zu gewährleisten 
              und unser Angebot zu verbessern. Weitere Informationen finden Sie in unserer{' '}
              <Link 
                to="/datenschutz" 
                className="text-[#00BFFF] hover:text-[#003366] font-medium underline"
              >
                Datenschutzerklärung
              </Link>.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:flex-shrink-0">
            <Button
              onClick={handleAcceptNecessary}
              variant="outline"
              className="border-slate-300 text-slate-700 hover:bg-slate-100 px-6 py-2 h-11 rounded-sm font-medium"
              data-testid="cookie-necessary-btn"
            >
              Nur notwendige Cookies
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="bg-[#003366] hover:bg-[#002244] text-white px-6 py-2 h-11 rounded-sm font-medium"
              data-testid="cookie-accept-btn"
            >
              Alle akzeptieren
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
